import React from 'react'


export const TapOptions = ({ tabs = [], selectIteam = 0 }) => {
    return (
        <div className="w-full ">
            <div className="w-full h-[55px] relative">
                <div className="w-full h-full grid grid-cols-3">
                    {tabs.map((iteam, index) => (
                        <div key={`${index}-iteam-header`} className="flex justify-center items-center gap-1 relative h-full w-full">
                            <div className={`${selectIteam === index && "font-semibold"}`}>
                                <span className='text-[8px] md:text-[12px]'>{iteam}</span>
                            </div>
                            <div className={`absolute z-10 h-[3px] w-full ${selectIteam === index && "bg-[#1677FF]"} bottom-0`}></div>
                        </div>
                    ))}
                </div>
            </div>
        </div>
    )
};

export default TapOptions